import { t } from '../../lib/i18n/t';
import { Mark } from './Mark';

interface WordmarkProps {
  size?: number;
}

export function Wordmark({ size = 22 }: WordmarkProps) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--space-2)',
        color: 'var(--text-1)',
        fontSize: 'var(--fs-3)',
        fontWeight: 500,
        letterSpacing: 'var(--ls-tight)',
      }}
    >
      <Mark size={size} />
      {t('SV Cloud')}
    </span>
  );
}
